// extracted by css-extract-rspack-plugin
var _1 = "zvvEpXjxjBIYDsg3";
var _2 = "XiH7Q7qqQpsHxb_Z";
var _3 = "XiH7Q7qqQpsHxb_Z";
var _4 = "h5jR0vQEVojzO1pw";
var _5 = "Mho6zhNsCIgCt7jN";
var _6 = "P6QGefQWFjon6FiJ";
var _7 = "mjmKuTtxyzoTvhFH";
var _8 = "P6QGefQWFjon6FiJ";
var _9 = "mjmKuTtxyzoTvhFH";
export { _1 as "identifier", _2 as "identifierWrapper", _3 as "identifier__wrapper", _4 as "rank", _5 as "score", _6 as "score--lose", _7 as "score--win", _8 as "scoreLose", _9 as "scoreWin" }
